import React from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import useCampaignBreadcrumbItems from './hooks/useCampaignBreadcrumbItems';
import useCreatorBreadcrumbItems from './hooks/useCreatorBreadcrumbItems';
import useListsBreadcrumbItems from './hooks/useListsBreadcrumbItems';

export function CampaignBreadcrumbsHeader() {
  const items = useCampaignBreadcrumbItems();

  return items?.length ? <Breadcrumbs items={items} /> : null;
}

export function CreatorBreadcrumbsHeader() {
  const items = useCreatorBreadcrumbItems();

  return items?.length ? <Breadcrumbs items={items} /> : null;
}

export function ListsBreadcrumbsHeader() {
  const items = useListsBreadcrumbItems();

  return items?.length ? <Breadcrumbs items={items} /> : null;
}
